"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.loadAllMeters = loadAllMeters;
exports.markMeterSaved = markMeterSaved;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _meterReadingApi = require("../api/meterReadingApi");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Actions
var LOAD_ALL_METERS = 'api/reducer/ALL_METERS';
var MARK_METER_SAVED = 'reduce/MARK_METER_SAVED';

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case LOAD_ALL_METERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        action: action.data.innerData
      });
    case MARK_METER_SAVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        meterSaved: [].concat((0, _toConsumableArray2.default)(state.meterSaved || []), [action.serialNo])
      });
    default:
      return state;
  }
}

// Action Creators
function loadAllMeters(dispatch) {
  var resp = (0, _meterReadingApi.getAllMeters)();
  return resp.then(function (response) {
    dispatch({
      type: LOAD_ALL_METERS,
      data: {
        innerData: response.data.content
      }
    });
  }).catch(function (e) {
    // eslint-disable-next-line no-console
    console.log(e);
  });
}
function markMeterSaved(dispatch, serialNo) {
  return dispatch({
    type: MARK_METER_SAVED,
    serialNo: serialNo
  });
}